import { HttpClient, HttpXhrBackend, HttpHeaders } from '@angular/common/http';
import { UserInfo } from './userInfo';
import { environment } from '../environments/environment';
import { AppConfigService } from './reactive-forms/services/app-config.service';
import { Injectable } from '@angular/core';
import { SBHttpServicesService } from './shared/services/sbhttp-services.service';
import { SharedHandlersService } from './shared/shared-handlers.service';
import Swal from 'sweetalert2';
import localeEn from '@angular/common/locales/en';
import localeAr from '@angular/common/locales/ar';
import localeFr from '@angular/common/locales/fr';
import localeFa from '@angular/common/locales/fa';
//import { type } from 'os';

@Injectable({
  providedIn: 'root'
})

export class Languges {

  public langItems: Array<{ text: string, value: number, preposition: string, direction: string, localeId: string, localeData: any }> = [
    { text: "English", value: 2, preposition: "en", direction: "ltr", localeId: "en-US", localeData: localeEn },
    { text: "Arabic - عربى", value: 1, preposition: "ar", direction: "rtl", localeId: "ar-EG", localeData: localeAr },
    { text: "French", value: 3, preposition: "fr", direction: "ltr", localeId:"fr-FR", localeData: localeFr },
    { text: "Persian - فارسي", value: 4, preposition: "fa", direction: "rtl", localeId: "fa-IR", localeData: localeFa }
  ];
  constructor(private environment: AppConfigService) { }

  public Language;
  async GetLanguage() {
    if (!this.Language || this.Language == undefined) {
      var accessToken = UserInfo.AccessToken;
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", this.environment.apiRoot + 'api/schema/GetDictionary/' + UserInfo.Language, false); // false for synchronous request
      xmlHttp.setRequestHeader('Authorization', `Bearer ${accessToken}`);
      xmlHttp.send(null);
      let lang = JSON.parse(xmlHttp.responseText);
      if (lang && lang["status"] && lang["status"] == 2) {
        Swal.fire({
          html: `<div>Error</div><div style=font-size:15px>${lang["message"]}</div>`,
          showCloseButton: true,
          background: '#fff url(assets/images/block_black_24dp.svg) center center no-repeat',
          showConfirmButton: false
        });
        return;
      }
      else
        this.Language = Array.of(lang)[0];
    }
    return this.Language;
  }
  public ClearLang() {
    this.Language = null;
  }
  public IsLoaded() {
    if (!this.Language || this.Language == undefined)
      return false
    return true;
  }
  public GetName(key: string): string {
    if (this.Language && key && typeof (key) == typeof ("string") && this.Language.hasOwnProperty(key.toLowerCase())) {
      return this.Language[key.toLowerCase()];
    }

    return key;
  }

  public GetLanguageKey(key: string): number {
    if (key == 'ar-EG')
      return LanguagesEnum.Arabic;

    else return LanguagesEnum.English;
  }

  public GetLanguageCode(key: number): string {
    if (key == LanguagesEnum.Arabic)
      return 'ar-EG';

    else if (key == LanguagesEnum.English)
      return 'en';

    else if (key == LanguagesEnum.Farsi)
      return 'fa-IR';

    else if (key == LanguagesEnum.French)
      return 'fr-FR';
    else
      return 'en';
  }
}

export enum LanguagesEnum {
  Arabic = 1,
  English = 2,
  Farsi =3 ,
  French =4
}
